import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const Navbar = () => {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Auto-close menu on window resize to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const linkStyle = (path) => {
    const isActive = pathname === path;
    return `relative block w-fit px-2 py-1 transition-all duration-200 ease-in-out after:absolute after:bottom-0 after:left-0 after:h-[1.5px] ${
      isActive
        ? 'text-[#c2a86e] font-semibold after:w-full after:bg-[#c2a86e]'
        : 'text-ivory hover:text-[#c0c0c0] after:w-0 hover:after:w-full after:transition-all after:duration-200 after:bg-[#c0c0c0]/60'
    }`;
  };

  return (
    <nav className="sticky top-0 z-50 bg-[#121316]/90 backdrop-blur-xl border-b border-[#c2a86e]/60 px-6 py-4 flex items-center justify-between">
      {/* Mobile: Hamburger Icon */}
      <div className="md:hidden z-50">
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="text-ivory text-2xl focus:outline-none"
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>

      {/* Logo */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className={`font-serif tracking-tight text-ivory hover:text-[#c2a86e] transition 
          text-2xl md:text-3xl
          ${menuOpen ? 'ml-auto' : 'md:ml-0'} 
          ${menuOpen ? 'md:hidden' : ''}
        `}
      >
        <Link to="/">shoot_me.eli</Link>
      </motion.div>

      {/* Desktop Nav */}
      <div className="hidden md:flex space-x-8 text-sm md:text-base font-light uppercase">
        <Link to="/" className={linkStyle('/')}>Work</Link>
        <Link to="/about" className={linkStyle('/about')}>About</Link>
        <Link to="/contact" className={linkStyle('/contact')}>Contact</Link>
      </div>

      {/* Mobile Sidebar Menu */}
      {menuOpen && (
        <div className="fixed top-0 left-0 h-screen w-[12rem] bg-[#121316]/80 backdrop-blur-xl border-r border-[#c2a86e]/30 flex flex-col items-start pt-20 pl-6 space-y-6 z-40">
          <Link to="/" onClick={() => setMenuOpen(false)} className={linkStyle('/')}>Work</Link>
          <Link to="/about" onClick={() => setMenuOpen(false)} className={linkStyle('/about')}>About</Link>
          <Link to="/contact" onClick={() => setMenuOpen(false)} className={linkStyle('/contact')}>Contact</Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;














